import React, { useCallback } from "react";

import Container from "../common/container";
import AlbumDisplay from "./AlbumDisplay";
import "./s1Header.css";
import ReactWebMediaPlayer from "react-web-media-player";
import ReactPlayer from "react-player";

import { loadHeaderContent } from "../../utils/cmsContentLoader";
import useCMSContent from "../../hooks/useCMSContent";

// Fallback data if CMS is not available
const fallbackHeaderData = {
  albumTitle: null,
  announcement: null,
  logo: null,
  logoMobile: null,
  albumCover: null,
  backgroundImage: null,
  featuredSong: null,
  featuredSong2: null,
};

const Header = () => {
  const { data: headerContent } = useCMSContent(
    loadHeaderContent,
    fallbackHeaderData
  );

  const handleImageError = useCallback((e) => {
    e.target.style.display = "none";
    console.error("Image failed to load:", e.target.src);
  }, []);

  // Use CMS content with fallbacks
  const title = headerContent?.albumTitle || fallbackHeaderData.albumTitle;
  const announcement =
    headerContent?.announcement || fallbackHeaderData.announcement;
  const logo = headerContent?.logo || fallbackHeaderData.logo;
  const logoMobile = headerContent?.logoMobile || fallbackHeaderData.logoMobile;
  const albumCover = headerContent?.albumCover || fallbackHeaderData.albumCover;
  const featuredSong =
    headerContent?.featuredSong || fallbackHeaderData.featuredSong;
  const featuredSong2 =
    headerContent?.featuredSong2 || fallbackHeaderData.featuredSong2;
  const backgroundImage =
    headerContent?.backgroundImage || fallbackHeaderData.backgroundImage;

  // Process first featured song
  const hasAudio1 =
    !!featuredSong?.audio && !!featuredSong?.title && !!featuredSong?.thumbnail;
  const hasVideo1 =
    !!featuredSong?.videoUrl &&
    featuredSong.videoUrl.length > 0 &&
    !!featuredSong?.title &&
    !!featuredSong?.thumbnail;

  const isVideo1Available = hasVideo1;
  const finalFeaturedSong = hasAudio1 || hasVideo1 ? featuredSong : null;
  const displayedFeaturedSong =
    finalFeaturedSong && isVideo1Available
      ? { ...finalFeaturedSong, audio: undefined }
      : finalFeaturedSong;

  // Process second featured song
  const hasAudio2 =
    !!featuredSong2?.audio && !!featuredSong2?.title && !!featuredSong2?.thumbnail;
  const hasVideo2 =
    !!featuredSong2?.videoUrl &&
    featuredSong2.videoUrl.length > 0 &&
    !!featuredSong2?.title &&
    !!featuredSong2?.thumbnail;

  const isVideo2Available = hasVideo2;
  const finalFeaturedSong2 = hasAudio2 || hasVideo2 ? featuredSong2 : null;
  const displayedFeaturedSong2 =
    finalFeaturedSong2 && isVideo2Available
      ? { ...finalFeaturedSong2, audio: undefined }
      : finalFeaturedSong2;

  // Don't block rendering - always show content with fallbacks
  return (
    <Container
      id="containerHeader"
      scrollId="one"
      scrollBehavior="center"
      className="default"
      style={
        backgroundImage && {
          backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.553), rgba(0,0,0,0.553)), url(${backgroundImage})`,
        }
      }
    >
      <AlbumDisplay
        albumCover={albumCover}
        logo={logo}
        logoMobile={logoMobile}
        title={title}
        onImageError={handleImageError}
        announcement={announcement}
      >
        {(displayedFeaturedSong || displayedFeaturedSong2) && (
          <div className="videos-container">
            {/* First Video/Audio */}
            {displayedFeaturedSong && (
              <div className="video-wrapper">
                {isVideo1Available ? (
                  <ReactPlayer
                    src={displayedFeaturedSong.videoUrl}
                    title={displayedFeaturedSong.title}
                    controls={true}
                    pip={true}
                    className="react-player"
                    width="100%"
                    height="100%"
                  />
                ) : (
                  <ReactWebMediaPlayer
                    width={200}
                    height={200}
                    title={displayedFeaturedSong.title}
                    thumbnail={displayedFeaturedSong.thumbnail}
                    audio={displayedFeaturedSong.audio}
                    vinyl={{
                      img: displayedFeaturedSong.thumbnail,
                      rpm: 15,
                    }}
                    style={{
                      backgroundColor: "transparent",
                      background: "transparent",
                      boxShadow: "white 1px 2px 15px",
                    }}
                  />
                )}
              </div>
            )}

            {/* Second Video/Audio */}
            {displayedFeaturedSong2 && (
              <div className="video-wrapper">
                {isVideo2Available ? (
                  <ReactPlayer
                    src={displayedFeaturedSong2.videoUrl}
                    title={displayedFeaturedSong2.title}
                    controls={true}
                    pip={true}
                    className="react-player"
                    width="100%"
                    height="100%"
                  />
                ) : (
                  <ReactWebMediaPlayer
                    width={200}
                    height={200}
                    title={displayedFeaturedSong2.title}
                    thumbnail={displayedFeaturedSong2.thumbnail}
                    audio={displayedFeaturedSong2.audio}
                    vinyl={{
                      img: displayedFeaturedSong2.thumbnail,
                      rpm: 15,
                    }}
                    style={{
                      backgroundColor: "transparent",
                      background: "transparent",
                      boxShadow: "white 1px 2px 15px",
                    }}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </AlbumDisplay>
    </Container>
  );
};

export default Header;
